import { useNavigate } from "react-router-dom"
import MainTitle from "../../components/template/MainTitle"
import ButtonWrap from "../../components/template/ButtonWrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import CustomSoundTable from "./CustomSoundTable"
import PageDescription from "../../components/template/PageDescription"

const CustomSoundPage = () => {
    const navigate = useNavigate()
    return (
        <div className='default-background'>
            <div className="flex justify-between items-center my-5">
                <MainTitle title="Custom Sound" />
                <ButtonWrap contents={<FontAwesomeIcon icon={faArrowLeft} />} onClick={() => navigate('/')} />
            </div>
            <div className="mb-4">
                <PageDescription contents={[
                    "On this page, you can track Custom Sound requests and open each one to follow its progress.",
                ]} />
            </div>
            <CustomSoundTable />
        </div>
    )
}

export default CustomSoundPage